module.exports = __webpack_public_path__ + "img/what's-new.bdb3f96a.svg";